import GalleryHoverContainer from "../../../../Components/Miscellaneous/Gallery/GalleryHover/GalleryHoverContainer";

const GalleryHover = () => {
  return <GalleryHoverContainer />;
};

export default GalleryHover;
